<!-- Contenedor con video de fondo (mismo que hero de la página web) -->
<div class="login-page">
  <div class="login-video-bg">
    <video #loginVideo muted loop playsinline preload="auto" class="login-video" [attr.muted]="true" [attr.playsinline]="true">
      <source src="assets/video.mp4" type="video/mp4">
      Tu navegador no soporta la reproducción de videos.
    </video>
    <div class="login-video-overlay"></div>
  </div>

  <!-- Modal de bienvenida DEMO (solo cuando no hay base de datos inicializada) -->
  <ng-container *ngIf="isDemoMode">
  <!-- Paso 1: Mensaje de bienvenida -->
  <div class="demo-welcome-overlay" *ngIf="showDemoWelcome">
    <div class="demo-welcome-modal demo-welcome-step1">
      <div class="demo-welcome-badge">
        <i class="fas fa-flask"></i>
        <span>Entorno de demostración</span>
      </div>
      <h2 class="demo-welcome-title">Bienvenido a Restora360</h2>
      <p class="demo-welcome-lead">
        Está a punto de explorar una <strong>versión de demostración</strong> con datos de ejemplo. Podrá probar todas las funcionalidades del sistema sin compromiso.
      </p>
      <div class="demo-welcome-notice">
        <i class="fas fa-clock"></i>
        <div>
          <strong>Importante:</strong> Los datos de esta demo se conservan durante <strong>24 horas</strong>. Pasado ese tiempo, la información se reinicia automáticamente.
        </div>
      </div>
      <div class="demo-welcome-next">
        <span class="demo-welcome-next-label">Al continuar, se configurará:</span>
        <ul class="demo-welcome-list">
          <li><i class="fas fa-check"></i> Menú y categorías de ejemplo</li>
          <li><i class="fas fa-check"></i> Mesas y zonas de sala</li>
          <li><i class="fas fa-check"></i> Usuarios de prueba para cada rol</li>
        </ul>
      </div>
      <button type="button" class="btn-demo-accept" (click)="acceptDemoWelcome()">
        <i class="fas fa-play"></i>
        Iniciar demostración
      </button>
    </div>
  </div>
  <!-- Paso 2: Inicializando... -->
  <div class="demo-welcome-overlay" *ngIf="demoInitInProgress">
    <div class="demo-welcome-modal demo-loading">
      <i class="fas fa-spinner fa-spin demo-spinner"></i>
      <p>Inicializando sistema con datos de prueba...</p>
    </div>
  </div>
  <!-- Paso 3: Credenciales para ingresar -->
  <div class="demo-welcome-overlay" *ngIf="showDemoCredentials">
    <div class="demo-welcome-modal">
      <div class="demo-welcome-icon demo-credentials-icon">
        <i class="fas fa-user-check"></i>
      </div>
      <h2>Listo para usar el demo</h2>
      <p class="demo-welcome-text">Puede ingresar con las siguientes credenciales:</p>
      <div class="demo-credentials-box">
        <p><strong>Usuario:</strong> {{ DEMO_USER }}</p>
        <p><strong>Contraseña:</strong> {{ DEMO_PASSWORD }}</p>
      </div>
      <p class="demo-welcome-sub">También puede usar: mesero/mesero123, cocinero/cocinero123, cajero/cajero123</p>
      <button type="button" class="btn-demo-accept" (click)="closeDemoCredentials()">
        Continuar
      </button>
    </div>
  </div>
</ng-container>

<!-- En modo DEMO: pantalla de carga hasta comprobar si la base está inicializada -->
<div class="login-container demo-checking" *ngIf="isDemoMode && !demoCheckDone">
  <div class="demo-welcome-modal demo-loading">
    <i class="fas fa-spinner fa-spin demo-spinner"></i>
    <p>Cargando...</p>
  </div>
</div>

<div class="login-container" *ngIf="!isDemoMode || demoCheckDone">
  <div class="login-card">
    <div class="login-header">
      <img src="assets/logo_sin_fondo.png" alt="Restora360" class="login-logo">
      <h1>Bienvenido a Restora360</h1>
      <p>Inicia sesión para continuar</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="username">
          <i class="fas fa-user"></i>
          Usuario
        </label>
        <input
          type="text"
          id="username"
          formControlName="username"
          placeholder="Ingrese su usuario"
          [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
        />
        <small *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched" class="error-text">
          Usuario requerido (mínimo 3 caracteres)
        </small>
      </div>

      <div class="form-group">
        <label for="password">
          <i class="fas fa-lock"></i>
          Contraseña
        </label>
        <input
          type="password"
          id="password"
          formControlName="password"
          placeholder="Ingrese su contraseña"
          [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
        />
        <small *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="error-text">
          Contraseña requerida (mínimo 6 caracteres)
        </small>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        <i class="fas fa-exclamation-circle"></i>
        {{ errorMessage }}
      </div>

      <button type="submit" class="btn-login" [disabled]="isLoading || loginForm.invalid">
        <i class="fas fa-sign-in-alt" *ngIf="!isLoading"></i>
        <i class="fas fa-spinner fa-spin" *ngIf="isLoading"></i>
        {{ isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
      </button>
    </form>
  </div>
</div>
</div>
